$(function() {

    var privateFunctions = {
        getTextInput:function(name,id,classes,defaultValue){
            return `<input type="text" name="${name}" class="${classes}" ${(!!id)?'id="'+id+'"':''} ${(!!defaultValue)?'value="'+defaultValue+'"':''} />`;
        },
        getTextAreaInput:function(name,id,classes,defaultValue){
            return `<textarea name="${name}" class="${classes}" ${(!!id)?'id="'+id+'"':''}>${defaultValue}</textarea>`;
        }
    };

});